import { Tabs, TabsProps } from "@mantine/core"
import useTabStyles from "./styles"

const Tab = (props: TabsProps) => {
    const {classes} = useTabStyles();
    return <Tabs classNames={classes} style={{width: "fit-content"}} {...props}/>
}

export default Tab